import { withWallClockTimes } from '../utils/events';
const BASE = process.env.REACT_APP_API_BASE_URL || '';
let timelogEmployeeId = null;

async function jsonFetch(path, init = {}) {
  const { body, headers, ...rest } = init;

  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    // keep caller method/other options
    ...rest,
    headers: {
      ...(headers || {}),
      ...(path.startsWith('/timelogs') && timelogEmployeeId
        ? { 'X-Timelog-Employee-Id': timelogEmployeeId }
        : {}),
      ...(body && !((headers || {})['Content-Type']) ? { 'Content-Type': 'application/json' } : {}),
    },
    body: body != null ? JSON.stringify(body) : undefined,
  });

  let data = null;
  try { data = await res.json(); } catch { data = null; }

  if (!res.ok) {
    const msg = (data && (data.message || data.error)) || `Request failed: ${res.status}`;
    const error = new Error(msg);
    error.status = res.status;
    error.data = data;
    throw error;
  }
  return data;
}

export const API = {
  // Auth
  checkAuth: () => jsonFetch('/check-auth'),
  login: () => jsonFetch('/login'),
  devLogin: (email) => jsonFetch('/dev-login', { method: 'POST', body: { email } }),
  ping: () => jsonFetch('/ping'),
  setTimelogEmployee: (employeeId) => { timelogEmployeeId = employeeId || null; },
  // refresh=true makes the server re-read CRM instead of serving its cached
  // copy — used on load / tab refocus so admin-side grant changes show up.
  fetchTimelogAccess: ({ refresh = false } = {}) => jsonFetch(`/timelog-access${refresh ? '?refresh=1' : ''}`),
  // EventSource can't send custom headers, so the employee id travels as a
  // query param here instead of the X-Timelog-Employee-Id header.
  timelogStreamUrl: (employeeId) => `${BASE}/timelogs/stream?employeeId=${encodeURIComponent(employeeId)}`,

  // Matters (Zoho CRM) and timelogs
  fetchProjects: () => jsonFetch('/matters'),
  fetchProjectsTimelogs: () => jsonFetch('/timelogs'),
  // The visible week, live from CRM (server holds it 45 s). start must be a Monday.
  fetchTimelogWeek: (start) => jsonFetch(`/timelogs/week?start=${encodeURIComponent(start)}`),
  fetchTimelogById: (logId) => jsonFetch(`/timelogs/${encodeURIComponent(logId)}`),

  // Timelogs (Zoho CRM, shared module with Outlook Sync)
  // Times go out as Danish clock text: see withWallClockTimes.
  createTimelog: (payload) => jsonFetch('/timelogs', { method: 'POST', body: withWallClockTimes(payload) }),
  createTimelogsBulk: (payload) => jsonFetch('/timelogs/bulk', {
    method: 'POST', body: { ...payload, events: (payload.events || []).map(withWallClockTimes) },
  }),
  updateTimelog: (payload) => jsonFetch(`/timelogs/${encodeURIComponent(payload.logId)}`, { method: 'PUT', body: withWallClockTimes(payload) }),
  deleteTimelog: (payload) => jsonFetch(`/timelogs/${encodeURIComponent(payload.logId)}`, { method: 'DELETE' }),
  deleteTimelogsBulk: (payload) => jsonFetch('/timelogs/bulk', { method: 'DELETE', body: payload }),

  // Work types by matter
  fetchTasksByProject: (projectId) =>
    jsonFetch(`/matters/${encodeURIComponent(projectId)}/work-types`),

  // User preferences
  getUserViewPreference: () => jsonFetch('/user/view-preference'),
  saveUserViewPreference: (view) => jsonFetch('/user/view-preference', { method: 'POST', body: { view } }),
};
